import React from 'react';
import PropTypes from 'prop-types';


const EmployeeCardField = ({ field, employee, handleOpenViewModal }) => {
  if (field.key === 'actions') {
    return (
      <div className="flex mt-2 space-x-2">
        <button className="text-sss-info mr-2" onClick={() => handleOpenViewModal(employee)}>
          View
        </button>
      </div>
    );
  }

  return (
    <p className="text-sm text-gray-600">
      {field.label}:{' '}
      {employee[field.key] 
      ? employee[field.key].toString() 
      : '-'}
    </p>
  );
};

EmployeeCardField.propTypes = {
  field: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default EmployeeCardField;
